<template>
    <activation-brief-networks-provider
        v-slot="{
            brief,
            contact,
            step,
            patchStep,
            goNextStep,
            goPreviousStep,
            isPreview,
            isLoading,
            isCompletingBrief,
            errors,
            errorMessage,
            forceReloadContact,
        }"
        style="height: 100%">
        <activation-brief-networks-view
            :brief="brief"
            :contact="contact"
            :step="step"
            :is-loading="isLoading"
            :is-completing-brief="isCompletingBrief"
            :error-message="errorMessage"
            @load-contact="forceReloadContact"
            @go-next-step="goNextStep"
            @go-previous-step="goPreviousStep"
            @patch-step="patchStep"
        />
    </activation-brief-networks-provider>
</template>

<script>
    import ActivationBriefNetworksProvider from '../providers/activation-brief-steps/ActivationBriefNetworksProvider';
    import ActivationBriefNetworksView from '../data-views/activation-briefs/ActivationBriefNetworksView';
    export default {
        name:       'ActivationBriefNetworksRouterView',
        components: {
            ActivationBriefNetworksView,
            ActivationBriefNetworksProvider,
        },
    };
</script>

<style scoped>

</style>
